export function getUserCountry() {
  const lang = navigator.language;
  const langRegion = lang.includes('-') ? lang.split('-')[1].toLowerCase() : lang.toLowerCase();

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const timeZoneToCountry: Record<string, string> = {
    // Bahrain
    'Asia/Bahrain': 'bh',

    // Belgium
    'Europe/Brussels': 'be',

    // Denmark
    'Europe/Copenhagen': 'dk',

    // Finland
    'Europe/Helsinki': 'fi',

    // France
    'Europe/Paris': 'fr',

    // Germany
    'Europe/Berlin': 'de',

    // Israel
    'Asia/Jerusalem': 'il',

    // Kuwait
    'Asia/Kuwait': 'kw',

    // Norway
    'Europe/Oslo': 'no',

    // Portugal
    'Europe/Lisbon': 'pt',

    // Qatar
    'Asia/Qatar': 'qa',

    // Saudi Arabia
    'Asia/Riyadh': 'sa',

    // Sweden
    'Europe/Stockholm': 'se',

    // Switzerland
    'Europe/Zurich': 'ch',

    // UAE
    'Asia/Dubai': 'ae',

    // USA — все основные таймзоны
    'America/New_York': 'US',
    'America/Chicago': 'US',
    'America/Denver': 'US',
    'America/Los_Angeles': 'US',
    'America/Anchorage': 'US',
    'America/Honolulu': 'US',
  };

  const countryFromTZ = timeZoneToCountry[tz];

  console.log(countryFromTZ, langRegion);

  return countryFromTZ || langRegion || 'DEFAULT';
}
